export const AddToCartIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.4 1.55C5.54164 1.36115 5.76393 1.25 6 1.25H18C18.2361 1.25 18.4584 1.36115 18.6 1.55L21.6 5.55C21.6974 5.67982 21.75 5.83772 21.75 6V20C21.75 20.7293 21.4603 21.4288 20.9445 21.9445C20.4288 22.4603 19.7293 22.75 19 22.75H5C4.27065 22.75 3.57118 22.4603 3.05546 21.9445C2.53973 21.4288 2.25 20.7293 2.25 20V6C2.25 5.83772 2.30263 5.67982 2.4 5.55L5.4 1.55ZM6.375 2.75L3.75 6.25V20C3.75 20.3315 3.8817 20.6495 4.11612 20.8839C4.35054 21.1183 4.66848 21.25 5 21.25H19C19.3315 21.25 19.6495 21.1183 19.8839 20.8839C20.1183 20.6495 20.25 20.3315 20.25 20V6.25L17.625 2.75H6.375Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H21C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.41421 21.4142 6.75 21 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 9.25C8.41421 9.25 8.75 9.58579 8.75 10C8.75 10.862 9.09241 11.6886 9.7019 12.2981C10.3114 12.9076 11.138 13.25 12 13.25C12.862 13.25 13.6886 12.9076 14.2981 12.2981C14.9076 11.6886 15.25 10.862 15.25 10C15.25 9.58579 15.5858 9.25 16 9.25C16.4142 9.25 16.75 9.58579 16.75 10C16.75 11.2598 16.2496 12.468 15.3588 13.3588C14.468 14.2496 13.2598 14.75 12 14.75C10.7402 14.75 9.53204 14.2496 8.64124 13.3588C7.75044 12.468 7.25 11.2598 7.25 10C7.25 9.58579 7.58579 9.25 8 9.25Z"
        fill="white"
      />
    </svg>
  )
}
